import React from 'react';
import { useFlipbookContext } from 'app/components/common/flipbook/lib/hooks';
import { useSelector } from 'app/store/utils/redux/hooks';
import { guard } from 'app/utils';

import PageCover from '../cover/Cover';
import PageContent from '../page-content/PageContent';
import PageVirtualGift from '../PageVirtualGift';
import PagePhysicalGift from '../PagePhysicalGift';
import PageRecord from '../page-record/PageRecord';
import PagePromo from '../page-promo/PagePromo';
import PageEnd from '../PageEnd';

interface IPageBuilder {
}

const PageBuilder: React.FC<IPageBuilder> = (props) => {
  const { pageId } = useFlipbookContext();
  const page = useSelector((state) => (state.card.pages || {})[pageId]);

  return (
    <>
      {guard.isCoverPage(page) && (
        <PageCover data={page} />
      )}
      {guard.isContentPage(page) && (
        <PageContent data={page} />
      )}
      {guard.isRecordPage(page) && (
        <PageRecord data={page} />
      )}
      {guard.isVirtualGiftPage(page) && (
        <PageVirtualGift data={page} />
      )}
      {guard.isPhysicalGiftPage(page) && (
        <PagePhysicalGift data={page} />
      )}
      {guard.isPromoPage(page) && (
        <PagePromo data={page} />
      )}
      {guard.isEndPage(page) && (
        <PageEnd data={page} />
      )}
    </>
  );
};

export default PageBuilder;
